export default __webpack_public_path__ + "static/media/bg15.6a8c8f9f.jpg";